<template>
  <el-card class="report-item">
    <div>
      <div class="title">
        <div style="display: flex; justify-content: space-between; align-items: center; min-height: 28px">
          <span v-if="option.title">
            {{ option.title }}
            <Tooltip :content="option.tooltip" :contentCustomr="config.tooltipCustomr"></Tooltip>
          </span>
          <!-- <template v-if="option.tooltip">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                <div v-html="option.tooltip"></div>
              </div>
              <i class="icon-a-01wenhao iconfont-elicon"></i>
            </el-tooltip>
          </template> -->
          <div class="btns-box" v-if="option.btns">
            <template v-for="(item, index) in option.btns">
              <el-tooltip :disabled="!item.tip" effect="dark" placement="top" :key="index">
                <div slot="content" v-show="item.tip">
                  <div>{{ item.tip }}</div>
                </div>
                <el-button
                  class="btn"
                  type="text"
                  :icon="item.loading ? 'el-icon-loading' : ''"
                  @click="!item.loading && onBtnClick(item)"
                >
                  <i :class="['iconfont', item.icon]" v-if="!item.loading"></i>
                </el-button>
              </el-tooltip>
            </template>
          </div>
          <div style="flex: 1; text-align: end" v-if="option.radioOptions || option.filterParam">
            <el-radio-group size="mini" v-model="option.radio" @change="handleFilter">
              <el-radio-button :label="item.value" v-for="item in option.radioOptions" :key="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
            <span v-if="option.filterTitle">{{ option.filterTitle }}</span>
            <el-select
              class="filter-select"
              v-if="option.filterParam"
              v-model="option.filter"
              :placeholder="option.filterPlaceholder ? option.filterPlaceholder : '请选择'"
              @change="handleFilter"
            >
              <el-option
                v-for="item in option.filterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="option.tip" class="tip">{{ option.tip }}</div>
        <slot name="other" :option="option"></slot>
      </div>
      <div
        class="table-box"
        :class="`${option.cancelShadow ? 'no-shadow' : ''}`"
        :style="`width: 100%;height:${option.height};overflow:hidden;position:relative;`"
      >
        <el-table
          :ref="option.ref"
          :data="option.tableData"
          @sort-change="sortChange"
          :height="option.height"
          @handleScrollEnd="onEnd"
        >
          <slot></slot>
          <noData
            slot="empty"
            class="no-data-empty"
            :custom="{ height: `${Number(option.height.replace('px', '')) - 57}px` }"
          ></noData>
        </el-table>
      </div>
    </div>
  </el-card>
</template>
<script>
import { BarWidth } from '@/utils'
import noData from '@/components/common/default-data'
import { mapState } from 'vuex'
import Tooltip from './tooltip'
export default {
  name: 'itemTable',
  components: { noData, Tooltip },
  props: {
    config: {
      default: () => {},
    },
  },
  computed: {
    ...mapState(['menu']),
  },
  watch: {
    config: {
      handler: function (config) {
        this.option = {
          ...this.option,
          ...config,
        }
        if (!this.charts) {
          this.initChart(this.option)
        } else {
          this.clientWidth = this.charts.clientWidth
        }
      },
      immediate: true,
      deep: true,
    },
    'menu.collapse': {
      handler: function (val) {
        if (this.charts) {
          this.clientWidth = this.charts.clientWidth
        }
      },
    },
  },
  activated() {
    setTimeout(() => {
      if (this.charts) {
        this.clientWidth = this.charts.clientWidth
      }
    }, 60)
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        if (this.charts) {
          setTimeout(() => {
            this.clientWidth = this.charts.clientWidth
          }, 60)
        }
      })
    })
  },

  data() {
    return {
      resize: null,
      charts: null,
      clientWidth: 0,
      option: {
        tableData: [],
        title: '',
        ref: 'table',
        height: '325px',
      },
      barWidth: BarWidth(),
    }
  },
  methods: {
    onEnd() {
      if (!this.option.offsetLoading) {
        this.$emit('onEnd')
      }
    },
    onBtnClick(emit) {
      if (emit.link) this.$router.push(emit.link)
      this.$emit('btns', emit)
    },
    handleFilter(value) {
      this.$emit('change', value)
    },
    initChart(option) {
      this.$nextTick(() => {
        const refs = this.$refs[this.option.ref]
        this.clientWidth = refs && refs.clientWidth
        this.charts = refs
      })
    },
    sortChange(column, prop, order) {
      this.$emit('sort-change', column, prop, order)
    },
  },
}
</script>
<style lang="scss" scoped>
.report-item {
  position: relative;
  margin-top: 18px;
}
.table-box {
  position: relative;
  &::after {
    content: '';
    display: block;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 2px;
    width: 99.2%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  }
}
.icon {
  color: $--color-info;
  margin-left: 5px;
}
.tip {
  margin-top: 4px;
  font-size: 12px;
  color: #9da1c3;
}
.title {
  margin-bottom: 16px;
  position: relative;
  .filter-select {
    width: 150px;
  }
}
.btns-box {
  // position: absolute;
  // right: 0;
  // top: -10px;
  .btn {
    color: #999 !important;
    padding: 0 !important;
  }
  .btn:hover {
    color: #0560fd !important;
  }
}
.no-shadow {
  &::after {
    content: none;
    display: block;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 2px;
    width: 99.2%;
    //background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  }
}
</style>
<style lang="scss">
.report-item {
  .icon {
    color: #999;
    font-size: 14px;
    margin-left: 5px;
  }
}
</style>
